import React from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './src/App';
import { ErrorBoundary } from './src/components/ErrorBoundary';
render(<ErrorBoundary data-id="element-0">
    <App data-id="element-1" />
  </ErrorBoundary>, document.getElementById('root'));